import React, { createContext, PropsWithChildren, useState, } from "react";
import { Outlet } from "react-router-dom";
import { SelectItemType } from "@evvve/ui-kit/dist/components/Select/SelectItemType";

export interface StreamDevicesSettings {
  userDevice: string;
  isCameraOn: boolean;
  isMicroOn: boolean;
  selectedCamera?: SelectItemType;
  selectedMicro?: SelectItemType;
  videoDevices?: MediaDeviceInfo[];
  audioDevices?: MediaDeviceInfo[];
  cameraPermissions: boolean;
  microPermissions: boolean;

  // setOverlayPause?: () => void, // avoid settings
  // removeOverlayPause?: () => void,
}

type BroadcastMetadata = {
  deviceSettings: StreamDevicesSettings|undefined,
  setDeviceSettings: React.Dispatch<React.SetStateAction<StreamDevicesSettings|undefined>>,
  // setOverlayPause: (() => void)|undefined,
}
export const BroadcastContext = createContext<BroadcastMetadata|null>(null);

export const BroadcastWrapper: React.FC<PropsWithChildren> = ({ children }) => {

  const [deviceSettings, setDeviceSettings] = useState<StreamDevicesSettings>();

  return (
    <BroadcastContext.Provider value={{ deviceSettings, setDeviceSettings }}>
      {children || <Outlet />}
    </BroadcastContext.Provider>
  );
};
